class Announcement extends HTMLElement {
  constructor() {
    super();
    this.delay = parseInt(this.dataset.delay, 10) || 5000;
    this.announcements = this.querySelectorAll('.announcement-bar');
    this.totalAnnouncements = this.announcements.length;
    if (this.totalAnnouncements < 2) return;
    this.currentAnnouncement = 1;

    this.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.addEventListener('scroll', this.setClasses.bind(this));
    this.setSlideVisibility();

    this.addEventListener('mouseover', this.pause.bind(this));
    this.addEventListener('mouseleave', this.play.bind(this));
    this.addEventListener('focusin', this.pause.bind(this));
    this.addEventListener('focusout', this.play.bind(this));
    this.play();
  }

  setClasses(event) {
    if (event.target.scrollLeft !== 0) return;
    event.target.classList.remove('reset');
  }

  setSlideVisibility() {
    this.announcements.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentAnnouncement - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  play() {
    this.setAttribute('aria-live', 'off');
    // Slide announcement every X seconds
    this.autoplay = setInterval(() => {
      this.next();
    }, this.delay);
  }

  next() {
    // scroll to next element
    const slideScrollPosition = this.currentAnnouncement === this.totalAnnouncements ? 0 : this.scrollLeft + this.querySelector('.announcement-bar').clientWidth;
    if (slideScrollPosition === 0) {
      this.classList.add('reset');
    }
    this.scrollTo({
      left: slideScrollPosition
    });
    this.currentAnnouncement = this.currentAnnouncement === this.totalAnnouncements ? 1 : this.currentAnnouncement + 1;
  }

  pause() {
    this.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }
}

customElements.define('announcement-component', Announcement);